<div class="flex flex-col">
  <app-table-search-input
    class="block mb-2"
    (searchDataEvent)="queryChanged($event)"
    inputWidth="100%"
    placeholder="Device Name, type & other"
  />

  <avs-li-filters-bar
    (filtersChanged)="filtersChanged($event)"
    [filters]="filtersBarValue()"
    [id]="sessionFiltersId()"
    [showUI]="showFiltersBar()"
  />

  <div
    class="overflow-auto -ml-[10px] mt-3"
    (scroll)="shadowShown.set($any($event).target.scrollTop > 0)"
    [class.bottom-shadow]="shadowShown()"
    [style.height]="scrollBlockHeight()"
    #scrolling
  >
    <virtual-scroller
      (vsEnd)="fetchMore($event)"
      [bufferAmount]="50"
      [enableUnequalChildrenSizes]="true"
      [items]="devices()"
      [parentScroll]="scrolling"
      #scroll
    >
      <div #container>
        @for (item of scroll.viewPortItems; track item.id) {
          @if (item.id !== masterDevice()?.id) {
            @if (isMultiSelect()) {
              <div class="flex items-center">
                <mat-checkbox
                  class="flex-1 text-sm avs-truncate"
                  (change)="toggleDevice(item)"
                  [checked]="selection.isSelected(item.id)"
                >
                  {{ item.deviceName }}
                </mat-checkbox>
                @if (itemTemplate()) {
                  <ng-container
                    [ngTemplateOutlet]="itemTemplate()!"
                    [ngTemplateOutletContext]="{ $implicit: item }"
                  />
                }
              </div>
            } @else {
              <div
                class="h-10 flex items-center justify-between px-3 text-sm text-ui-dark cursor-pointer"
                (click)="selectDevice(item)"
                [class.text-ui-green-light]="selection.isSelected(item.id)"
              >
                {{ item.deviceName }}
                @if (itemTemplate()) {
                  <ng-container
                    [ngTemplateOutlet]="itemTemplate()!"
                    [ngTemplateOutletContext]="{ $implicit: item }"
                  />
                }
                @if (selection.isSelected(item.id)) {
                  <i class="icon-check text-ui-green-light text-3xl"></i>
                }
              </div>
            }
          }
        }
      </div>
    </virtual-scroller>
  </div>
</div>
